import React from 'react';
import { Link } from '@ui-kit-ngs/atoms';
import { SelectionButton } from '@ui-kit-ngs/molecules';
import { StyledContainer, StyledContent, StyledEventName, StyledEventInfo, StyledRow, StyledContentInfo, StyledInfoName, StyledContentLabels, StyledBlurbContainer, StyledBlurb, } from './styled-components';
import { EpicValueHeader } from './EpicValueHeader';
export const EpicValueCard = ({ eventLink, eventName, oldOddsInfo, headerInfoText, selectionName, selectionButton, concessionType, blurb, cardsCount, device, }) => {
    return (React.createElement(StyledContainer, { cardsCount: cardsCount, device: device },
        React.createElement(EpicValueHeader, { headerInfoText: headerInfoText, concessionType: concessionType }),
        React.createElement(StyledContent, null,
            React.createElement(StyledRow, null,
                eventLink && (React.createElement(StyledEventName, null,
                    React.createElement(Link, { className: "non-route", href: eventLink.href, onClick: eventLink.onClick }, eventName))),
                !eventLink && React.createElement(StyledEventName, null, eventName),
                React.createElement(StyledEventInfo, null, oldOddsInfo)),
            React.createElement(StyledContentInfo, null,
                React.createElement(StyledInfoName, null, selectionName),
                React.createElement(StyledContentLabels, null,
                    React.createElement(SelectionButton, Object.assign({}, selectionButton))))),
        blurb && (React.createElement(StyledBlurbContainer, null,
            React.createElement(StyledBlurb, null, blurb)))));
};
